const PRE_SURGERY_INTERVENTION = 'preSurgeryIntervention';
export default PRE_SURGERY_INTERVENTION;
